<template>
  <div class="mx-0.5 h-5 w-px shrink-0 bg-border" />
</template>
